<script>
    export default {
        props: {
            id: {
                type: String
            },
            package: {
                type: Object,
                default: null
            },
        },
        data() {
            return {
                recipient: '',
                subject: '',
                loading: false,
            }
        },
        mounted() {
            this.subject = this.package.package_name;
        },
        methods: {
            sendMail() {
                this.loading = true;
                axios.post(Scoop.baseUrl + '/mediaserver/packages/' + this.package.id + '/sendMail', {
                    recipient: this.recipient,
                    subject: this.subject,
                }).then(response => {
                    $('#' + this.id).modal('hide');
                    toastr.success('E-mail has been sent successfully', {timeOut: 5000});
                    this.recipient = '';
                    this.loading = false;
                }).catch(error => {
                    toastr.error(error.response.data.message, 'E-mail could not be sent', {timeOut: 5000});
                    this.loading = false;
                });
            },
        },
    }
</script>
<template>
    <div class="panel panel-default animated fadeInDown">
        <div class="panel-body">
            <form class="form-horizontal">
                <div class="form-group">
                    <label class="col-sm-2 control-label" v-text="__('scoop-os.packages.share.mail.recipient')"></label>
                    <div class="col-sm-10">
                        <input type="email" name="email" class="form-control" placeholder="user@example.com" v-model="recipient"
                               autofocus>
                    </div>
                </div>
                <div class="hr-line-dashed"></div>
                <div class="form-group">
                    <label class="col-sm-2 control-label" v-text="__('scoop-os.packages.share.mail.subject')"></label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="subject"
                               @click="$event.target.select()">
                    </div>
                </div>
            </form>
        </div>
        <div class="panel-footer text-right">
            <button type="button" :class="['btn btn-primary', loading ? 'disabled' : '']" @click="sendMail">
                <span v-text="__('scoop-os.packages.share.mail.button_label')"></span>
                <i class="fa fa-paper-plane-o m-l-xs" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</template>
